import React from 'react'

import { Link } from 'gatsby'
import styled from 'styled-components'

import { Container } from 'src/components/partials/Container'

const MinimalHeaderWrapper = styled.div`
  padding: 1.75rem 0 1rem;
  position: relative;
  z-index: 2;
`

export const MinimalHeader = () => (
  <MinimalHeaderWrapper>
    <Container>
      <Link to='/'>
        <img
          alt='Flatfile logo'
          src={
            '//images.ctfassets.net/hjneo4qi4goj/33l3kWmPd9vgl1WH3m9Jsq/13861635730a1b8af383a8be8932f1d6/flatfile-black.svg'
          }
          height={24}
          style={{ marginTop: '0.75rem' }}
        />
      </Link>
    </Container>
  </MinimalHeaderWrapper>
)
